import { memo } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from 'react-bootstrap';
import Link from 'components/Link';
import {
  setCurrentModal,
  MODAL_SELECT_STORE,
} from 'stores/reducers/store-selection-modal';
import toCapitalize from 'utils/to-capitalize';

const getNoActiveVariantsOOO = (category) =>
  `This item is no longer available.  For more items like this, shop our ${toCapitalize(
    category
  )} category.`;

const OOOBanner = ({
  allVariantsOOS,
  anyActiveVariants,
  category,
  inStockSomeVariant,
  noStoreSelected,
  someVariantsOOS,
  storeClosed,
  storeClosedMessage,
  storeSelection,
}) => {
  const dispatch = useDispatch();

  return (
    <div className="py-15 px-18 d-flex flex-column bg-light-grey mb-15">
      <p
        className="font-roboto fs-9 text-primary"
        data-value="variant-stock-info-message"
      >
        {storeClosed
          ? storeClosedMessage
          : storeSelection
          ? anyActiveVariants
            ? inStockSomeVariant
              ? someVariantsOOS
              : allVariantsOOS
            : getNoActiveVariantsOOO(category)
          : noStoreSelected}
      </p>
      {anyActiveVariants || !storeSelection || storeClosed ? (
        <Button
          className="font-sofia fw-700 text-uppercase"
          data-value="oos-select-store-button"
          type="button"
          variant="primary"
          onClick={() => dispatch(setCurrentModal(MODAL_SELECT_STORE))}
        >
          Select a store
        </Button>
      ) : (
        <Link
          href={`/shop/category/${category}`}
          type="button"
          className="btn btn-primary font-sofia fw-700 text-uppercase"
          data-value="no-active-variant-category-page-link"
        >
          {`Shop ${category}`}
        </Link>
      )}
    </div>
  );
};

export default memo(OOOBanner);
